<div
    class="select kk-select"
    *ngIf="control"
    [ngClass]="{ 'margin-small': marginBottom === 'small', 'margin-default': marginBottom === 'default' }"
>
    <label
        class="label kk-select__label"
        [for]="control | controlToKeyName"
        [ngClass]="{ 'kk-visuallyhidden': showError }"
    >
        {{ label }}
    </label>
    <label *ngIf="showError" class="label" [for]="control | controlToKeyName">
        {{ control | controlToKeyName | validationErrorMessage | translate }}
    </label>
    <div class="kk-select__wrapper">
        <select
            class="kk-select__select"
            [id]="control | controlToKeyName"
            [ngClass]="{ 'input-error': showError }"
            [formControl]="formControl"
            [name]="control | controlToKeyName"
        >
            <option [ngValue]="''" [selected]="'selected'" [attr.disabled]="isRequired" [attr.hidden]="isRequired">
                {{ placeholder }}
            </option>
            <ng-container *ngFor="let option of options">
                <option [ngValue]="option.value">{{ option.text }}</option>
            </ng-container>
        </select>
        <div class="icon kk-select__icon">
            <app-svg-icon iconName="chevron_down"></app-svg-icon>
        </div>
    </div>
</div>
